<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="8.3"
      stroke="currentColor"
      stroke-width="1.6"
    />
    <path
      d="M12 3.7V20.3"
      stroke="currentColor"
      stroke-width="1.6"
    />
    <path
      d="M12 8L19.3 8"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
    />
    <path
      d="M12 12L19.3 12"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
    />
    <path
      d="M12 16L19.3 16"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
    />
  </svg>
</template>
